import {ICityVoyagerObj} from '../pages/common/redux/types';

export default function transformToVoyagerObject(
  cityName: string,
  cityId: string,
  t = '',
): ICityVoyagerObj {
  return {
    _id: cityId,
    n: cityName,
  };
}
